import axios from "axios";
import { setAuthHeader } from "app/services/auth.header.service";
import * as ActivityStatsEnpointUtil from "utils/endpointUtils/activityStatsEndpointUtil";
import { getUrlForAllActivityTypesByClient, getUrlToDeleteActivity } from "utils/endpointUtils/activitiesEndpointUtil";

export const loadActivityStatsWeeklyBetweenDatesFromBackend = async (fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsWeeklyBetweenDates(fromDate, toDate);
    return await axios.get(url, config);
}

export const loadActivityStatsMonthlyBetweenDatesFromBackend = async (fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsMonthlyBetweenDates(fromDate, toDate);
    return await axios.get(url, config);
}

export const loadActivityStatsMonthlyByClientBetweenDatesFromBackend = async (clientId, fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsMonthlyByClientBetweenDates(clientId, fromDate, toDate);
    return await axios.get(url, config);
}

export const loadActivityStatsWeeklyByOwnerBetweenDatesFromBackend = async (memberId, fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsWeeklyByOwnerBetweenDates(memberId, fromDate, toDate);
    return await axios.get(url, config);
}

export const loadActivityStatsMonthlyByOwnerBetweenDatesFromBackend = async (memberId, fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsMonthlyByOwnerBetweenDates(memberId, fromDate, toDate);
    return await axios.get(url, config);
}

export const loadActivityStatsWeeklyByOwnerForCurrentMonthFromBackend = async (memberId) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsWeeklyByOwnerForCurrentMonth(memberId);
    return await axios.get(url, config);
}

export const loadActivityStatsMonthlyByOwnerForCurrentMonthFromBackend = async (memberId) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsMonthlyByOwnerForCurrentMonth(memberId);
    return await axios.get(url, config);
}

export const loadActivityStatsMonthlyConsolidatedBetweenDatesFromBackend = async (fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsMonthlyConsolidatedBetweenDates(fromDate, toDate);
    return await axios.get(url, config);
}

export const loadActivityStatsWeeklyConsolidatedBetweenDatesFromBackend = async (fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsWeeklyConsolidatedBetweenDates(fromDate, toDate);
    return await axios.get(url, config);
}

export const loadActivityStatsMonthlyConsolidatedForCurrentMonthFromBackend = async () => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsMonthlyConsolidatedForCurrentMonth();
    return await axios.get(url, config);
}

export const loadActivityStatsWeeklyConsolidatedForCurrentMonthFromBackend = async () => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = ActivityStatsEnpointUtil.getUrlForActivityStatsWeeklyConsolidatedForCurrentMonth();
    return await axios.get(url, config);
}

export const deleteActivity = async (activityId) => {
    const config = setAuthHeader();
    
    if(config === null) { 
        throw new Error("Invalid Auth Header or Token Expired");
    }

    const url = getUrlToDeleteActivity(activityId);

    return await axios.delete(url, config);
};

export const loadAllActivityTypesByClient = async (clientId) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForAllActivityTypesByClient(clientId);
    return await axios.get(url, config);
}